import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
  Alert,
} from '@mui/material'
import { Servicos } from './mockData'
import { styles } from './styles'
import Header from './Header'

const TelaServico = ({ onVoltar, onAvancar }) => (
  <>
    <Header voltar={onVoltar} />
    <Box sx={{ flex: 1, overflow: 'auto', py: 3, px: 2 }}>
      <Typography
        variant="h6"
        sx={{ color: '#59a68d', fontWeight: 600, mb: 2 }}
      >
        Escolha um Serviço
      </Typography>

      <Grid container spacing={2}>
        {Servicos.map((servico) => (
          <Grid item xs={12} sm={6} md={4} key={servico.id}>
            <Card sx={styles.card}>
              <CardActionArea onClick={() => onAvancar(servico)} sx={{ p: 2 }}>
                <CardContent sx={{ p: 0 }}>
                  <Typography variant="subtitle1" fontWeight={600}>
                    {servico.nome}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Duração: {servico.duracaoMin} min
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Valor: {servico.valor}
                  </Typography>
                  {servico.descricao && (
                    <Alert
                      severity="info"
                      sx={{
                        mt: 1,
                        backgroundColor: '#e3f2fd',
                        color: '#1565c0',
                      }}
                    >
                      {servico.descricao}
                    </Alert>
                  )}
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  </>
)

export default TelaServico
